// /User/ui_design/src/App.js
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";

// Always-on layout pieces
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";

// Routed pages
import Home from "./Components/Home";
import PatientPlatform from "./Components/PatientPlatform";

function App() {
  const [loader, setLoader] = useState(false);
  const [counter, setCounter] = useState({
    food: 0,
    patients: 0,
    ride: 0,
    volunteer: 0,
  });

  useEffect(() => {
    // Set your live numbers here
    setCounter({ food: 52, patients: 81, ride: 43, volunteer: 26 });
    setLoader(true);
  }, []);

  if (!loader) {
    return (
      <div className="spinner-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <Router>
      {/* Header (logo + menu) */}
      <Nav />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home counter={counter} />} />
        <Route path="/register/*" element={<PatientPlatform />} />
      </Routes>

      {/* Footer */}
      <Footer />
    </Router>
  );
}

export default App;
